<template>

  <div style="padding-bottom: 300px;">
     <div>
       开奖数据

     </div>
		 
		 <div class="lastinfoBox">
					 <div>
						  第<span style="color: red;">{{record.number}}</span> 期  {{record.time}}
					 </div>
					 <div>
						  <p class="num"> <span>{{record.simple1}}</span><span>{{record.simple2}}</span><span>{{record.simple3}}</span><span>{{record.simple4}}</span>
							<span>{{record.simple5}}</span><span>{{record.simple6}}</span><span>{{record.complex}}</span></p>
							<p class="num"> <span v-for="(item) in record.animalJson">{{item}}</span>
							</p>
					 </div>
						
		 </div>
		 <div>
			 <div>
				 正在等待开奖期数: <span> {{record.nextNumber}}</span> - <span> {{record.nextTime}}</span>
			 </div> 
			 <div class="openBox">
				 <div>填写开奖数据</div>
				 <div class="openNumBox" style="display: flex;justify-content: flex-start;">
					 <div>
						   1:<Input v-model="formData.num1"   type="number"  size="small" placeholder="" style="width: 80px;height: 40px;" />
					 </div>
					 <div>
					 						   2:<Input v-model="formData.num2" type="number"  size="small" placeholder="" style="width: 80px;height: 40px;" />
					 </div>
					 <div>
					 						   3:<Input v-model="formData.num3"  type="number" size="small" placeholder="" style="width: 80px;height: 40px;" />
					 </div>
					 <div>
					 						   4:<Input v-model="formData.num4"  type="number" size="small" placeholder="" style="width: 80px;height: 40px;" />
					 </div>
					 <div>
					 						   5:<Input v-model="formData.num5"  type="number" size="small" placeholder="" style="width: 80px;height: 40px;" />
					 </div>
					 <div>
					 						  6:<Input v-model="formData.num6"  type="number" size="small" placeholder="" style="width: 80px;height: 40px;" />
					 </div>
					 <div>
					 						   特码:<Input v-model="formData.complex"  type="number" size="small" placeholder="" style="width: 80px;height: 40px;" />
					 </div>
					 

					 
					 
				 </div>
				 <div>
					  <div>
					 						 下期开奖期数<Input v-model="formData.nextNumber"   type="number"  size="small" placeholder="" style="width: 80px;height: 40px;" />
					  </div>
						<div>
											 下期开奖时间<DatePicker type="datetime" format="yyyy-MM-dd HH:mm"  placeholder="Select date and time" style="width: 200px" @on-change='setDate'></DatePicker>
    
						</div>
				 </div>
				 <div style="margin-top: 60px;">
					   <Button @click="submitBtn">确认开奖</Button>
					 
				 </div>
				 
				 
			 </div>
			 
			 
		 </div>
    <div>

    </div>

  </div>
</template>

<script>

  export default{
    			created(){  //生命周期里接收参数
  // console.log(this.baseURL )
                this.getData()
								this.getNext()
    	},
    	data(){
    		 return {
    			  record:[],
						openDate:'',
						formData:{
							num1:'',
							num2:'',
							num3:'',
							num4:'',
							num5:'',
							num6:'',
							complex:'',
							nextTime:'',
							nextNumber:'',
						}
    			 }
    	},
    	methods:{
    		   getData() {
                         var params = {
                           pageNum:2,
                           pageSize:10,
						   year:2020
                         }

                      	  this.post('/apis/mark/record/get',params).then(res => {
                          	console.log(res)
                            if(res.status == 1){
//                                   this.record = res.data.records[0]
//                                   // replace(/-/g,'')
// 
//                                   var anima = this.record.animalName.replace(/-/g,'')
//                                   // str.charAt(2)
//                                 console.log(anima)
//                                   var arr=[]
//                                   for(var i =0;i<7;i++){
//                                     arr.push(anima.charAt(i))
//                                   }
// 																	this.record.animalJson = arr
//                                   console.log(arr)
                             
                            }

                          }).catch(err => {             //
                            console.log(err)
                          });


                  },
                 setDate(e){
									 console.log(e)
									 this.formData.nextTime = e
									 
								 },
								 submitBtn(){
									 console.log(0)
									         var params = this.formData
									 
									  this.post('/apis/mark/record/add',params).then(res => {
									  	console.log(res)
									    if(res.status == 1){
									          
									     
									    }
									 
									  }).catch(err => {             //
									    console.log(err)
									  });
								 },
								 getNext(){
									   this.post('/apis/mark/record/getNextLottery').then(res => {
									 	console.log(res)
									   if(res.status == 1){
									         this.record.nextNumber = res.data.nextNumber
													  this.record.nextTime = res.data.nextTime
													 
									    
									   }
									 									 
									 }).catch(err => {             //
									   console.log(err)
									 });
									 mark/record/getNextLottery
								 }


              }

    }



</script>

<style>
	 .num span{
		 padding: 0 10px;
	 };
	  .num span:nth-last-child{
			color: #42B983;
			font-size: 30px;
		}
		.openNumBox{
			display: flex;
			justify-content: flex-start;
		}
		.openNumBox div{
			margin-right: 20px;
		}
			.openNumBox input{
				height: 30px;
			}
			.openBox{
				border: 1px solid lightslategray;
				padding: 10px 20px;
			}
</style>



// WEBPACK FOOTER //
// src/components/list.vue